import PageHeaderController from './page-header.controller';

require('./page-header.scss');

const PageHeaderComponent = {
    selector: 'sbPageHeader',
    controller: PageHeaderController,
    template: require('./page-header.html'),
};

export default PageHeaderComponent;



// WEBPACK FOOTER //
// ./src/app/components/page-header/index.js